import { createDeferredI18n } from "#/shared/composables/useI18n";

import fallbackMessages from "#/shared/i18n/frontend.availability_filter.json";

export const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "availability_filter", fallbackMessages });

/**
 * Translates an availability-filter string. Keys are relative to `frontend.availability_filter`,
 * which the i18n endpoint serves as the message root, and resolve per client through that client's
 * own locale files.
 *
 * @param {String} key
 * @returns {String}
 */
export function t(key) {
  return i18n.global.t(key);
}

/**
 * Translates a string a client may leave blank. Returns undefined for a blank or missing message,
 * where `t` would return the key itself.
 *
 * @param {String} key
 * @returns {String|undefined}
 */
export function optionalText(key) {
  if (!i18n.global.te(key) && !i18n.global.te(key, "en")) {
    return undefined;
  }

  const text = i18n.global.t(key).trim();

  return text === "" || text === key ? undefined : text;
}
